import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IUserInfo } from '@ruby/modules/account/models/contact.interface';
import * as UTOriginBatchWeighActions from '@ruby/modules/unit-train/store/actions/ut-origin-batch-weigh.actions';
import * as fromUTOriginBatchWeigh from '@ruby/modules/unit-train/store/reducers/ut-origin-batch-weigh.reducer';
import * as UTOriginBatchWeighSelectors from '@ruby/modules/unit-train/store/selectors/ut-origin-batch-weigh.selectors';

@Component({
  selector: 'ng-ut-origin-batch-weigh-container',
  templateUrl: './ut-origin-batch-weigh.container.html',
  styleUrls: ['./ut-origin-batch-weigh.container.scss']
})
export class UTOriginBatchWeighContainer {
  store$: Observable<{ state: fromUTOriginBatchWeigh.State; userInfo?: IUserInfo }>;

  constructor(private store: Store<{ state: fromUTOriginBatchWeigh.State; userInfo?: IUserInfo }>) {
    this.store$ = this.store.select(UTOriginBatchWeighSelectors.selectOriginBatchWeight);
  }

  /**
   * Search Origins
   *
   * @summary
   * @param $search: string
   * @returns void
   */
  searchOrigins($search: string): void {
    this.store.dispatch(UTOriginBatchWeighActions.getOrigins({ data: { commodity: ['CL'], search: $search } }));
  }

  /**
   * Search Coal Density
   *
   * @summary
   * @param $originId: string
   * @returns void
   */
  searchCoalDensity($originId: string): void {
    this.store.dispatch(UTOriginBatchWeighActions.getCoalDensity({ data: $originId }));
  }

  /**
   * Submit Report
   *
   * @summary
   * @param $report: { coalDensity: number; originId: number; recipient: string }
   * @returns void
   */
  submitReport($report: { coalDensity: number; originId: number; recipient: string }): void {
    this.store.dispatch(UTOriginBatchWeighActions.submitReport({ data: $report }));
  }
}
